import React from "react";
import { Outlet } from "react-router-dom";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

const GlobalLayout = () => {

  return (

    <div className="global-layout">

      <Header />

      <main>
        <Outlet />
      </main>

      <Footer />

    </div>

  );

};

export default GlobalLayout;